import React from 'react';
import { Check, CheckCircle } from 'lucide-react';
export function FeaturesSection() {
  return <section className="py-20 bg-white" data-id="element-89">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-90">
        <div className="text-center mb-16" data-id="element-91">
          <h2 className="text-4xl md:text-5xl font-extrabold text-[#1E3A5F] mb-4" data-id="element-92">
            QUÉ TE LLEVÁS HOY
          </h2>
          <div className="w-24 h-1.5 bg-[#F59E0B] mx-auto rounded-full" data-id="element-93"></div>
        </div>

        <div className="bg-slate-50 border border-slate-200 rounded-3xl p-8 md:p-12 shadow-xl mb-16 relative overflow-hidden" data-id="element-94">
          <div className="absolute top-0 right-0 bg-[#1E3A5F] text-white px-6 py-2 rounded-bl-2xl font-bold" data-id="element-95">
            BASE
          </div>

          <h3 className="text-3xl font-bold text-[#1E3A5F] mb-6" data-id="element-96">
            MEGA PACK APRENDIZAJE LECTURA™
          </h3>

          <p className="text-xl font-semibold text-[#16A34A] mb-8" data-id="element-97">
            192 lecturas narrativas + 192 fichas de actividades para todo el año
          </p>

          <div className="mb-10" data-id="element-98">
            <h4 className="text-lg font-bold text-slate-800 mb-4 uppercase tracking-wide" data-id="element-99">
              Cada semana incluye:
            </h4>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-100">
              {['Texto narrativo de 10 renglones adaptado al nivel del grado', 'Preguntas de comprensión lectora', 'Actividades de reflexión personal', 'Espacio de producción escrita', 'Progresión pedagógica de marzo a diciembre'].map((item, i) => <li key={i} className="flex items-start bg-white p-4 rounded-xl shadow-sm border border-slate-100" data-id="element-101">
                  <Check className="w-6 h-6 text-[#F59E0B] mr-3 flex-shrink-0" data-id="element-102" />
                  <span className="text-slate-700 font-medium" data-id="element-103">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Mobile: Cards */}
          <div className="md:hidden space-y-4" data-id="element-104">
            {[{
            grado: '1º Grado',
            foco: 'Reconocimiento de letras y fluidez básica',
            desc: '32 lecturas cortas con oraciones simples, imágenes de apoyo y actividades de identificación de letras, sílabas y palabras clave.'
          }, {
            grado: '2º Grado',
            foco: 'Comprensión de tramas y vocabulario',
            desc: '32 textos narrativos con preguntas de secuencia, personajes y vocabulario contextual. Incluye actividades de escritura guiada.'
          }, {
            grado: '3º Grado',
            foco: 'Comprensión inferencial e inicio de análisis',
            desc: '32 lecturas con preguntas inferenciales, causa-efecto y opinión personal. Ejercicios de resumen y producción de párrafos breves.'
          }, {
            grado: '4º Grado',
            foco: 'Textos expositivos, leyendas y noticias',
            desc: '32 textos variados (cuentos, leyendas, noticias) con análisis de estructura textual, idea principal y producción escrita argumentativa.'
          }, {
            grado: '5º Grado',
            foco: 'Argumentación y reflexión ciudadana',
            desc: '32 lecturas con temáticas sociales y ambientales. Actividades de debate, postura crítica y redacción de textos de opinión fundamentada.'
          }, {
            grado: '6º Grado',
            foco: 'Pensamiento crítico y análisis profundo',
            desc: '32 textos complejos con análisis multicapa, comparación de fuentes, producción de ensayos breves y preparación para secundaria.'
          }].map((item, i) => <div key={i} className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm" data-id="element-105">
                <div className="bg-[#1E3A5F] text-white font-bold px-3 py-1 rounded-lg inline-block text-sm mb-3" data-id="element-106">
                  {item.grado}
                </div>
                <p className="font-semibold text-slate-800 mb-2" data-id="element-107">{item.foco}</p>
                <p className="text-sm text-slate-600" data-id="element-108">{item.desc}</p>
              </div>)}
          </div>

          {/* Desktop: Table */}
          <div className="hidden md:block overflow-x-auto rounded-xl border border-slate-200 shadow-sm" data-id="element-109">
            <table className="w-full text-left border-collapse" data-id="element-110">
              <thead data-id="element-111">
                <tr className="bg-[#1E3A5F] text-white" data-id="element-112">
                  <th className="p-4 font-bold text-lg w-1/5" data-id="element-113">Grado</th>
                  <th className="p-4 font-bold text-lg w-1/4" data-id="element-114">Foco del Año</th>
                  <th className="p-4 font-bold text-lg" data-id="element-115">Qué incluye</th>
                </tr>
              </thead>
              <tbody className="bg-white" data-id="element-116">
                <tr className="border-b border-slate-100" data-id="element-117">
                  <td className="p-4 font-bold text-slate-800" data-id="element-118">1º Grado</td>
                  <td className="p-4 text-slate-600" data-id="element-119">
                    Reconocimiento de letras y fluidez básica
                  </td>
                  <td className="p-4 text-slate-600" data-id="element-120">
                    32 lecturas cortas con oraciones simples, imágenes de apoyo
                    y actividades de identificación de letras, sílabas y
                    palabras clave.
                  </td>
                </tr>
                <tr className="border-b border-slate-100 bg-slate-50/50" data-id="element-121">
                  <td className="p-4 font-bold text-slate-800" data-id="element-122">2º Grado</td>
                  <td className="p-4 text-slate-600" data-id="element-123">
                    Comprensión de tramas y vocabulario
                  </td>
                  <td className="p-4 text-slate-600" data-id="element-124">
                    32 textos narrativos con preguntas de secuencia, personajes
                    y vocabulario contextual. Incluye actividades de escritura
                    guiada.
                  </td>
                </tr>
                <tr className="border-b border-slate-100" data-id="element-125">
                  <td className="p-4 font-bold text-slate-800" data-id="element-126">3º Grado</td>
                  <td className="p-4 text-slate-600" data-id="element-127">
                    Comprensión inferencial e inicio de análisis
                  </td>
                  <td className="p-4 text-slate-600" data-id="element-128">
                    32 lecturas con preguntas inferenciales, causa-efecto y
                    opinión personal. Ejercicios de resumen y producción de
                    párrafos breves.
                  </td>
                </tr>
                <tr className="border-b border-slate-100 bg-slate-50/50" data-id="element-129">
                  <td className="p-4 font-bold text-slate-800" data-id="element-130">4º Grado</td>
                  <td className="p-4 text-slate-600" data-id="element-131">
                    Textos expositivos, leyendas y noticias
                  </td>
                  <td className="p-4 text-slate-600" data-id="element-132">
                    32 textos variados (cuentos, leyendas, noticias) con
                    análisis de estructura textual, idea principal y producción
                    escrita argumentativa.
                  </td>
                </tr>
                <tr className="border-b border-slate-100" data-id="element-133">
                  <td className="p-4 font-bold text-slate-800" data-id="element-134">5º Grado</td>
                  <td className="p-4 text-slate-600" data-id="element-135">
                    Argumentación y reflexión ciudadana
                  </td>
                  <td className="p-4 text-slate-600" data-id="element-136">
                    32 lecturas con temáticas sociales y ambientales.
                    Actividades de debate, postura crítica y redacción de textos
                    de opinión fundamentada.
                  </td>
                </tr>
                <tr className="bg-slate-50/50" data-id="element-137">
                  <td className="p-4 font-bold text-slate-800" data-id="element-138">6º Grado</td>
                  <td className="p-4 text-slate-600" data-id="element-139">
                    Pensamiento crítico y análisis profundo
                  </td>
                  <td className="p-4 text-slate-600" data-id="element-140">
                    32 textos complejos con análisis multicapa, comparación de
                    fuentes, producción de ensayos breves y preparación para
                    secundaria.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-141">
          <div className="flex items-center bg-green-50 px-6 py-3 rounded-full border border-green-200" data-id="element-142">
            <CheckCircle className="w-6 h-6 text-[#16A34A] mr-2" data-id="element-143" />
            <span className="font-bold text-green-800" data-id="element-144">
              Escuela pública y privada
            </span>
          </div>
          <div className="flex items-center bg-green-50 px-6 py-3 rounded-full border border-green-200" data-id="element-145">
            <CheckCircle className="w-6 h-6 text-[#16A34A] mr-2" data-id="element-146" />
            <span className="font-bold text-green-800" data-id="element-147">
              Turno mañana y tarde
            </span>
          </div>
          <div className="flex items-center bg-green-50 px-6 py-3 rounded-full border border-green-200" data-id="element-148">
            <CheckCircle className="w-6 h-6 text-[#16A34A] mr-2" data-id="element-149" />
            <span className="font-bold text-green-800" data-id="element-150">
              Impresión o proyección
            </span>
          </div>
        </div>
      </div>
    </section>;
}